export function readXsrf(): string | null {
    const m = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/);
    return m?.[1] ? decodeURIComponent(m[1]) : null;
}

export function getCookie(name: string): string | null {
    const m = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'),
    );
    return m?.[1] ? decodeURIComponent(m[1]) : null;
}

export function isCsrfTokenValid(): boolean {
    const token = getCookie('XSRF-TOKEN');
    return !!token;
}
